import {getField, updateField} from 'vuex-map-fields';
import * as API from '@/api';

function initialState () {
  return {
    list: [],
  };
}

const state = initialState ();

// actions
const actions = {
  async list (context, payload) {
    var response = await API.country.list (payload);
    context.commit ('set_list', response);
    return response.countries;
  },
};

// getters
const getters = {
  getField,
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.countries;
  },

  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
